import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Button from '../ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { FiCalendar } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const Layout = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col selection:bg-veloura-primary/50">
      <Navbar />
      
      <AnimatePresence mode="wait">
        <motion.main 
          key={location.pathname}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.4 }}
          className="flex-grow pt-20" // Offset for fixed navbar
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>

      <Footer />

      {/* Floating Booking Button for Mobile */}
      <div className="fixed bottom-6 right-6 z-40 lg:hidden">
        <Button 
          to="/book" 
          variant="primary" 
          className="!rounded-full w-14 h-14 !p-0 shadow-xl flex items-center justify-center bg-veloura-accent hover:bg-veloura-text"
          aria-label="Book Appointment"
        >
          <SafeIcon icon={FiCalendar} className="w-6 h-6" />
        </Button>
      </div>
    </div>
  );
};

export default Layout;